import React from 'react';
import { SectionHeader } from 'components/common/override-rates/SectionHeader';
import { observer } from 'mobx-react-lite';
import { useOverrideQuotedRatesPageStore } from 'store/modules/override-rates/override-quoted-rates/pageStore';
import {
  ProductItemStyled,
  ProductLineTitleV2Styled,
  ProductListStyled,
  ProductNameStyled,
  ProductSummaryStyled,
  SectionStyled,
} from './styles';
import { QUOTED_RESULTS_PRODUCT_ITEM_TEST_ID } from '../constants';

export const QuotedResultsSection: React.FC = observer(() => {
  const { overrideProducts, portfolioProductLineId } = useOverrideQuotedRatesPageStore();

  return (
    <SectionStyled>
      <SectionHeader title="Current Rates" />
      <ProductLineTitleV2Styled productLineId={portfolioProductLineId} />
      <ProductListStyled>
        {overrideProducts.map(({ productLineId, productId, productName, productSummary }) => (
          <ProductItemStyled key={`productItem_${productId}_Quoted`} data-test-id={QUOTED_RESULTS_PRODUCT_ITEM_TEST_ID}>
            <ProductNameStyled>{productName}</ProductNameStyled>
            <ProductSummaryStyled
              key={`productSummary_${productId}_Quoted`}
              productSummary={productSummary}
              rateTitle="Quoted Rates"
              productLineId={productLineId}
              isRenewOrCancelProductLine={false}
              sectionRatesQuantity={productSummary.rates.length}
              $side="left"
            />
          </ProductItemStyled>
        ))}
      </ProductListStyled>
    </SectionStyled>
  );
});
